import { HttpMethod } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { TRANSFER_LINK_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';
import {
  ExpiredLinkPasswordRequest,
  ExpiredLinkPasswordResponse,
} from './types';

export function useCheckExpiredLinkPasswordMutationApi(id: string) {
  return useBaseMutation<
    ExpiredLinkPasswordRequest,
    ExpiredLinkPasswordResponse
  >(
    {
      url: `${TRANSFER_LINK_ROOT_ENDPOINT}/${id}`,
      method: HttpMethod.post,
      params: {
        action: 'check',
      },
    },
    {
      doNotShowErrorNotification: true,
    }
  );
}
